module.exports = __webpack_public_path__ + "img/bre8.93c65f26.png";